import React, { useState } from "react";

const About = () => {
  const [expanded, setExpanded] = useState(false);

  const shortText =
    "RT Jobspot is your trusted partner in digital growth. We understand the challenges of standing out online and are here to help you connect with your audience effectively.";

  const fullText =
    shortText +
    " Our expertise spans social media enhancement, ROI-driven advertising campaigns, and tailored digital strategies. We are passionate about turning your unique business journey into a success story. Partner with us for dedicated support from a team of digital innovators committed to your growth.";

  return (
    <section
      id="about"
      className="bg-gradient-to-br from-[#f8f5ef] via-white to-[#eef4ff] py-16"
    >
      <div className="mx-auto flex max-w-5xl flex-col items-center px-4">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-secondary-light to-secondary text-3xl shadow-[0_15px_30px_rgba(212,166,74,0.25)]">
          ✦
        </div>

        <h2 className="mb-4 text-3xl font-black text-primary-dark md:text-4xl">
          About RT Jobspot
        </h2>

        <div className="w-full max-w-3xl rounded-3xl border border-slate-200 bg-white/85 p-6 shadow-[0_20px_50px_rgba(15,23,42,0.08)] backdrop-blur-lg md:p-8">
          <p className="text-lg leading-8 text-slate-700 md:text-xl">
            {expanded ? fullText : shortText}{" "}
            <button
              onClick={() => setExpanded(!expanded)}
              className="font-bold text-secondary underline-offset-4 hover:underline focus:outline-none"
            >
              {expanded ? "See Less" : "See More"}
            </button>
          </p>
        </div>

        <div className="mt-8 w-full max-w-3xl rounded-3xl bg-gradient-to-r from-slate-950 via-primary to-primary-light p-6 text-center text-white shadow-[0_20px_50px_rgba(11,18,32,0.25)] md:p-8">
          <h3 className="mb-2 text-2xl font-black md:text-3xl">
            Join Us on Your Growth Journey
          </h3>
          <p className="mx-auto mb-5 max-w-2xl text-slate-200">
            Ready to elevate your digital presence? Contact RT Jobspot today and
            let’s create success together.
          </p>
          <a
            href="#contact"
            className="inline-block rounded-full bg-gradient-to-r from-secondary-light to-secondary px-6 py-3 font-bold text-slate-950 shadow-[0_12px_30px_rgba(212,166,74,0.35)] transition hover:scale-105"
          >
            Get in Touch
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
